import { Record, List } from "immutable";
import moment from "moment";

import { AccountCarrierField } from "./account-carrier-field";
import { ShippingCarrier } from "./shipping-carriers";

const defaults = {
    active: undefined,
    carrierId: undefined,
    createdOn: undefined,
    externalId: undefined,
    id: undefined,
    modifiedOn: undefined,
    shippingAccountId: undefined,
    fields: undefined,
    meta: undefined,
    max_weight: undefined,
    min_weight: undefined,
    markup_rate: undefined,
    default_container_units: undefined,
    default_container_height: undefined,
    default_container_width: undefined,
    default_container_length: undefined,
    is_drop_ship: undefined,
};

export class AccountCarrier extends Record(defaults) {
    declare active: boolean;
    declare archived: boolean;
    declare carrierId: string;
    declare createdOn: moment.Moment;
    declare externalId: string;
    declare id: string;
    declare modifiedOn: moment.Moment;
    declare shippingAccountId: string;
    declare apiEndpoint: string;
    declare name: string;
    declare fields: List<any>;
    declare meta: any;
    declare max_weight: number;
    declare min_weight: number;
    declare markup_rate: number;
    declare default_container_units?: string;
    declare default_container_height?: number;
    declare default_container_width?: number;
    declare default_container_length?: number;
    declare is_drop_ship: boolean;

    constructor(args) {
        super({
            ...args,
            carrierId: args.carrier_id,
            externalId: args.external_id,
            createdOn: moment.utc(parseInt(args.created_on, 10)),
            modifiedOn: moment.utc(parseInt(args.modified_on, 10)),
            shippingAccountId: args.shipping_account_id,
            fields: List(args.fields && args.fields.map((val) => new AccountCarrierField(val))),
            meta: args.meta ? new ShippingCarrier(args.meta) : new ShippingCarrier({}),
        });
    }
}
